import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";

import SaveAltIcon from "@material-ui/icons/SaveAlt";
import Button from "@material-ui/core/Button";

import "mapbox-gl/dist/mapbox-gl.css";
import DecorImage from "../Media/decor.png";
import SelectMenu from "../Menus/SelectMenu";
import gpxFile from "../Media/ggc5k.gpx";

// import ReactMapboxGl, { NavigationControl } from "react-mapbox-gl";
import ReactMapboxGl, { ZoomControl } from "react-mapbox-gl";

const styles = theme => ({
	downloadLink: {
		textDecoration: "none"
	},
	cardHeader: {
		backgroundColor: theme.palette.primary.color["100"]
	},
	avatar: {
		backgroundColor: theme.palette.secondary.color["500"]
	},
	media: {
		height: 520
	},
	card: {
		backgroundColor: theme.palette.white,
		paddingLeft: 20,
		paddingRight: 20
	}
});
const TOKEN =
	"pk.eyJ1IjoiaWRhbm1hbnR6dXIiLCJhIjoiY2pudm16MTVpMDB4bTN2bzNtbWx2dmU1byJ9.DPx2g0j_XRd2wdgvz9XY4A";

const Map = ReactMapboxGl({
	accessToken: TOKEN,
	minZoom: 8,
	maxZoom: 20,
	scrollZoom: false,
	dragPan: window.screen.width > 600
});

class MapCard extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			mapStyle: "mapbox://styles/idanmantzur/cjnxm0nt30eem2smxd0oqp4yr",
			center: [25.935872, -24.649277],
			zoom: window.screen.width > 600 ? [14.5] : [14]
		};
	}
	componentDidMount() {
		window.addEventListener("resize", this.resize);
		this.resize();
	}

	componentWillUnmount() {
		window.removeEventListener("resize", this.resize);
	}
	resize = () => {
		this.setState({
			viewport: {
				...this.state.viewport,
				width: this.props.width || window.innerWidth,
				height: this.props.height || window.innerHeight / 2
			}
		});
	};

	onStyleChange = mapStyle => {
		console.log(mapStyle);
		if (mapStyle === "Satellite") {
			this.setState({
				mapStyle: "mapbox://styles/idanmantzur/cjnxm0nt30eem2smxd0oqp4yr"
			});
		} else {
			this.setState({
				mapStyle: "mapbox://styles/idanmantzur/cjnxkdd267fy82rpe7p9nyf05"
			});
		}
	};

	render() {
		const { classes } = this.props;
		const { viewport, mapStyle, center, zoom } = this.state;
		return (
			<Card className={classes.card}>
				<img src={DecorImage} alt={"decor"} />
				<CardContent>
					<Map
						{...viewport}
						style={mapStyle}
						containerStyle={{
							height: 400,
							maxWidth: "calc(100% - 20px)",
							borderRadius: 20
						}}
						center={center}
						zoom={zoom}
					>
						<ZoomControl />
						<SelectMenu response={this.onStyleChange} />
					</Map>
				</CardContent>
				<CardActions>
					<a
						href={gpxFile}
						download="GGC5K.gpx"
						className={classes.downloadLink}
					>
						<Button
							variant="outlined"
							color="primary"
							className={classes.button}
						>
							<SaveAltIcon />
							Download GPX file
						</Button>
					</a>
				</CardActions>
			</Card>
		);
	}
}

MapCard.propTypes = {
	classes: PropTypes.object.isRequired
};

export default withStyles(styles)(MapCard);
